import React from 'react';
import { StudyGuideMatterRow } from './study-guide-matter-row';
import { Table, TableBody, TableHeaderWrapper, TableNoData } from '@/components/ui/table';
import { EmptyState } from '@/components/custom/empty-state';

export function StudyGuideMatterDataGrid({ data }) {
  const TABLE_HEAD = [{ label: 'Matéria' }, { label: 'Submatéria' }, { label: '', width: 160 }, { label: 'Ações', width: 160 }];

  return (
    <Table className="min-w-[800px]">
      <TableHeaderWrapper tableHead={TABLE_HEAD} />

      <TableBody>
        {data?.map(matter => (
          <StudyGuideMatterRow
            matter={matter}
            key={matter.id}
          />
        ))}

        <TableNoData
          notFound={!data?.length}
          colSpan={4}
          emptyState={
            <EmptyState
              variant="plain"
              type="data"
              title="Sem matérias"
              text="Adicione alguma matéria"
            />
          }
        />
      </TableBody>
    </Table>
  );
}
